import { defineStore } from "pinia";
import { useFetch } from '#app';
import { ulid } from "ulid";
import { useCookie } from "~/composable/useCookie";
import { useToastStore } from "~/stores/toast";
import { getItemFromIndexDB, addItemToIndexDB } from "~/utils/helpers/dbManager";

const baseUrlCiBiz = import.meta.env['VITE_CI_BIZ_URL']
const baseUrlProduct = import.meta.env['VITE_PRODUCT_URL']
const baseUrlCellar = import.meta.env['VITE_CELLAR_URL']

// @ts-ignore
export const useFileManagerStore = defineStore("FileManagerStore", {
  state: () => ({}),
  getters: {},
  actions: {
    async uploadFile(file: File) {
      const toastStore = useToastStore();
      const { getCookie } = useCookie();
      const filename = file.name
      console.log("fileName: ", filename)

      try {
        const { data, status, message } = await $fetch<any>(`${baseUrlCiBiz}/upload/${filename}`, {
          method: "POST",
          body: file,
          headers: {
            Authorization: `Bearer ${getCookie("accessToken")}`,
            "Content-Length": file.size,
            "Content-Type": file.type,
          },
        });
        if (status != 200) {
          throw ("error")
        }
        console.log(data)
        return data
      } catch (err: any) {
        console.log(err);
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error"
        });
        throw err;
      }
    },
    async uploadFileProductExcel(file: File) {
      const toastStore = useToastStore();
      const { getCookie } = useCookie();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("content-type", file.type);

      try {
        const res = await $fetch<any>(`${baseUrlProduct}/products/importData`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${getCookie("accessToken")}`,
          },
        });
        console.log("uploadFileProductExcel: ", res);
        return res
      } catch (err: any) {
        console.error(err);
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error"
        });
        throw err;
      }
    },

    async deleteFile(id: string) {
      const toastStore = useToastStore();
      try {
        const data = await $fetch<any>("/api/recording/file/remove", {
          method: "POST",
          body: { id }
        });
        return true
      } catch (err: any) {
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error"
        });
        return false
      }
    },
    async downloadFile(params: any, download: boolean = true) {
      const { getCookie } = useCookie();
      const cookie = getCookie("accessToken");
      const res: any = await $fetch(
        `${baseUrlCiBiz}/download/${params.id}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${cookie}`,
          },
        }
      )
      if (res) {
        const url = URL.createObjectURL(res);
        if (!download) return url;
        this.downloadFileInSystem(url, params.name)
      }
    },

    // cellar
    async downloadFileCellar(params: any, download: boolean = true) {
      const { getCookie } = useCookie();
      const cookie = getCookie("accessToken");
      const res: any = await $fetch(
        `${baseUrlCellar}/download/${params.type}/${params.id}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${cookie}`,
          },
        }
      )
      if (res) {
        const url = URL.createObjectURL(res);
        if (!download) return url;
        this.downloadFileInSystem(url, params.name)
      }
    },

    async getFile(url: string, name: string) {
      const response = await fetch(url);
      const blob = await response.blob();

      const file = new File([blob], name, { type: blob.type });
      return file;
    },

    async downloadFileInSystem(url: string, name: string) {
      try {
        // const response = await fetch(url, { method: 'HEAD' })
        // if (!response.ok) throw new Error('File not accessible')

        const element = document.createElement('a')
        element.href = url
        element.download = name
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      } catch (error) {
        console.error('Download failed:', error)
      }
    }
  },
});
